// extracted by mini-css-extract-plugin
export default {"questions":"payment-form_questions__YE26Y","echeck":"payment-form_echeck__pES8W","verified":"payment-form_verified__7tTXX","element":"payment-form_element__J6lqG"};